export default "__VITE_ASSET__4e066018__"